// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m4nsw","textarea":"styles_textarea__3X_yC"};